import { render, staticRenderFns } from "./VehChas.vue?vue&type=template&id=7066e0f9&"
import script from "./VehChas.vue?vue&type=script&lang=js&"
export * from "./VehChas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports